<template>
  <b-card
    no-body
    border-variant="light"
    :class="getCardClass(isClickable, isClickable)"
    @click="interceptionClickHandler"
  >
    <div class="tag-new" v-if="isNew($props.featureName)">
      {{ getLabelNew() }}
    </div>
    <b-card-body class="custom-card--body">
      <div class="tam-control-up">
        <i
          :class="'custom-card--icon-card ' + $props.headerIcon"
          v-if="!$props.icon"
        >
        </i>
        <img :src="resolve_img_url($props.icon)" v-else />
      </div>
      <div class="tam-control-down">
        <b-card-text class="p-card-text">
          <h5 class="custom-card--title">
            {{ $props.title }}
          </h5>
          <span class="custom-card--description">
            {{ $props.description }}
          </span>          
        </b-card-text>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import resolve_img_url from "../../utils/image/image-utils";
import { getNewByName } from "../../utils/news/news-utils";
import {
  validateShowNewness,
  saveNewness,
} from "../../services/newness/newness-new.js";

export default {
  props: [
    "headerIcon",
    "title",
    "description",
    "onCardClick",
    "responsive",
    "icon",
    "featureName",
  ],
  setup(props) {
    const invalidHandler = function invalidHandler(e) {
      console.warn("Invalid card click handler", e);
    };

    const onClickHandler = props.onCardClick || invalidHandler;
    const isClickable = !!props.onCardClick;

    const getCardClass = (isClickable) => {
      return (
        "custom-card custom-card--size-control " +
        (isClickable ? " custom-card--pointer " : "")
      );
    };

    return { onClickHandler, isClickable, getCardClass };
  },
  methods: {
    async interceptionClickHandler() {
      const checkValidateShowNewness = await validateShowNewness();

      if (checkValidateShowNewness) {
        const currentNew = getNewByName(this.$props.featureName);
        if (currentNew && currentNew?.lastLevel) {
          saveNewness(currentNew?.idConfigurationNewness);
          this.$store.dispatch(
            "removeNewness",
            currentNew?.idConfigurationNewness
          );
        }
      }
      this.onClickHandler();
    },
    isNew() {
      const currentNew = getNewByName(this.$props.featureName);
      if (currentNew) {
        return true;
      }
      return false;
    },
    getLabelNew() {
      const currentNew = getNewByName(this.$props.featureName);
      switch (currentNew?.type) {
        case "NEWNESS":
          return "Novidade";
        default:
          return "Novo";
      }
    },
    resolve_img_url: resolve_img_url,
  },
};
</script>

<style lang="scss" scoped>

.p-card-text {
  width: 100%;
  text-align: center;
}
.tam-control {
  &-up {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    margin-bottom: 1rem;
  }
  &-down {
    width: 100%;
    padding: 1rem 0;
  }
}

.custom-card {
  &--pointer {
    cursor: pointer;
  }

  &--size-control {
    width: 100%;       
    max-width: 20rem;  
    
  }

  &--body {
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: flex-start; 
    padding: 32px 16px;
    min-height: 250px; 
  }

  &--icon-card {
    color: var(--green-0);
    font-size: 5.8rem;
  }

  &--title {
    color: #212529;
    font-family: "Trebuchet MS";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }

  &--description {
    color: #212529;    
    font-family: "Trebuchet MS";
    font-size: 12.8px;
  }
}
.tag-new {
  background: #b1d34b 0% 0% no-repeat padding-box;
  border-radius: 12px;
  opacity: 1;
  color: #ffffff;
  text-align: center;
  width: 80px;
  height: 22px;
  position: absolute;
  top: -8px;
  right: 20px;
  padding-top: 2px;
}
</style>
